import { all } from 'redux-saga/effects';
import Auth from './Auth';
import Language from './Language';

export default function* rootSaga(getState) {
  yield all([
    Auth(),
    Language()
  ]);
}
